import TweenMax from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
//import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

//import 'imports-loader?define=>false!gsap/src/uncompressed/plugins/CSSRulePlugin';
//import './js/vendors/slick.js';

import "./js/product-modal.js";

if ( process.env.NODE_ENV == "production" ) {
  require( "./scss/main-production.scss" );
} else {
  require( "./scss/main-development.scss" );
}




var S20 = window.S20 || {};
S20.settings = S20.settings || {};


S20.settings = {
  "isDevice": false,
  "isApp": false,
  "isIE": false,
  "isIOS":false,
  "parallaxEnabled": true,
  "scrollMagicController": false,
  "scrollMagicDesktopController":false,
  "sectionCount": 0, //keeps track of how many times scrolling changed pages, resets with other nav
  "sectionId":{'women-01':'womens-everyday','women-02':'womens-hike','women-03':'womens-run','women-04':'womens-climb','men-01':'mens-everyday','men-02':'mens-hike','men-03':'mens-run','men-04':'mens-climb'},
};

  // Common
  S20.common = {

    "init"() {
      const deviceAgent = navigator.userAgent.toLowerCase();
      const matchDevice = ( deviceAgent.match( /(iphone|ipod|ipad)/ )
      || deviceAgent.match( /(android)/ )
      || deviceAgent.match( /(iemobile)/ )
      || deviceAgent.match( /iphone/i )
      || deviceAgent.match( /ipad/i )
      || deviceAgent.match( /ipod/i )
      || deviceAgent.match( /blackberry/i )
      || deviceAgent.match( /bada/i ) );


      const isIE = deviceAgent.match( /(msie|trident|edge)/ );

      if ( isIE ) {
        S20.settings.isIE = true;
      }

    const isIOS = deviceAgent.match( /(iphone|ipod|ipad)/ );

    if (isIOS) {
        S20.settings.isIOS = true;
    }

      //var msie = window.document.documentMode;//equals 11 on IE11, undefined on other browsers

      S20.settings.isDevice = Boolean( matchDevice );

      const matchApp = deviceAgent.match( /(mobileappv2)/ );
      S20.settings.isApp = Boolean( matchApp );


      //let firstSection = S20.settings.sectionId(Object.keys(S20.settings.sectionId)[0]);
      let firstSection = 'womens-everyday';//Object.keys(S20.settings.sectionId)[0];
      var hash = window.location.hash.substr(1);
      if (hash && hash != undefined && hash !== undefined && hash != 'undefined'){

        //if (firstSection in S20.settings.sectionId){

          firstSection = hash;

        //}

      }
      //console.log('first change section',hash);
      //console.log('firstSection',firstSection);

      //this is the only section change not using men-01,men-02 id's, it has to use
      S20.changeSection(firstSection,'init');




      /* test creating flex columns
      let height = 0;
      $(".container").first().find("> div").each(function(index){
        if (index <3){
          console.log($(this).height());
          height = height + $(this).height() + 30;
        }
      })
      $(".container").first().css("height",height);
      */
      console.log('page');
    if ($(".slick-photo-group").length > 0 && $("#mobile-sized").is(":visible")){
      $(".slick-photo-group").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite:true,
        dots: true,
        arrows:false,
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,
        speed:200,
      });
    }

    /*
    if (!$("#mobile-sized").is(":visible")){
      $(that.refs.slick).slick("unslick");
    }*/

    },

  };








  S20.addHandlers = function () {


      $("body").on("click", ".profile, .profile .indicate-icon", function () {

          var sectionID = $(this).parents(".section-container").attr("id");

          S20.trackPropEvent("prop70", "eVar70", 'profileClick:' + sectionID + ':' + $(this).data("panel"));

          $(this).toggleClass('active');

    } );
    var timerId;
    $("body").on( "mouseover", ".profile .indicate-icon", function() {

      clearTimeout(timerId);

      if ($("body").hasClass("desktop")){
        let $panel = $(this).parent().parent();


        timerId = setTimeout(() => {

            var sectionID = $(this).parents(".section-container").attr("id");

            S20.trackPropEvent("prop70", "eVar70", 'profileHover:' + sectionID + ':' + $(this).data("panel"));

            $panel.toggleClass('active');

        }, 1400)
      }
    });
    $("body").on( "mouseleave", ".profile .indicate-icon", function() {
      let $panel = $(this).parent().parent();
      $panel.removeClass('active');
      clearTimeout(timerId);
    });


    //flip between mens/womens in the flyout nav
    $( ".desktop .nav-panel__selection" )
      .hover( function () {
        S20.goToNavSection(this);
      } );

    $( ".device .nav-panel__selection" )
        .click(function (e) {
            if (!$(this).hasClass("selected")) {
                e.stopPropagation();
                S20.goToNavSection(this);
            }
      } );





    //open the flyout nav
    $( ".nav-bar__icon" )
      .click( () => {
        // $( ".nav-panel" ).toggleClass( "open" );

        if ($("body").hasClass("nav-open")) {
            S20.trackPropEvent("prop70", "eVar70", 'navClose');
        } else {
            S20.trackPropEvent("prop70", "eVar70", 'navOpen');
        }

        $( "body" )
          .toggleClass( "nav-open" );


        // No navigation transition color wipe, only section change
        $( ".nav-panel__transition" ).removeClass( "section-change" );
    } );


    //click the background or title in a section of the flyout nav
    $( ".nav-panel__section" )
        .click(function () {


            S20.settings.sectionCount = 0;

            const sectionSelected = $( this )
              .find( ".nav-panel__selection.selected" )
              .data( "section" );

            S20.changeSection(S20.settings.sectionId[sectionSelected], 'navButton');

            //S20.settings.sectionId[sectionSelected] == womens-hike
            //sectionSelected  == women-02

            S20.trackPropEvent("prop70", "eVar70", 'navPanelClick:' + S20.settings.sectionId[sectionSelected]);

            /*
            $( ".nav-panel__transition" )
              .addClass( "section-change" );
              */

            $( "body" )
              .toggleClass( "nav-open" );
    } );


      //click mens or womens in hero
      $(".background-panel__content-nav a").click(function(e){
            e.preventDefault();
            S20.settings.sectionCount = 0;

            /* toggle doesn't matter if we change pages
            $(this).parent().find("a").removeClass("selected");
            $(this).addClass("selected");
            */

            let nextSectionNumber = $(this).parent().data("section");
            let nextSectionName = $(this).data("section");
            let nextSection = nextSectionName + "-" + nextSectionNumber;

            S20.trackPropEvent("prop70", "eVar70", 'navHeroLinkClick:' + S20.settings.sectionId[nextSection]);

            S20.changeSection(S20.settings.sectionId[nextSection], 'navButton' );

      })

      //click arrows in hero
      $(".nav-arrow").click(function(){

            S20.settings.sectionCount = 0;

            $( "body" ).addClass( "header-nav" );

            let nextSectionNumber = $(this).data("section");
            let nextSectionName = $(this).parent().find(".selected").data("section");
            let nextSection = nextSectionName + "-" + nextSectionNumber;

            S20.trackPropEvent("prop70", "eVar70", 'navHeroArrowClick:' + S20.settings.sectionId[nextSection]);

            S20.changeSection(S20.settings.sectionId[nextSection], 'navButton' );


      })


      //footer that displays after scrolling through 4 panels
      $(".background-panel__button--mens").click(function(e){
            e.preventDefault();
            S20.settings.sectionCount = 0;
            S20.trackPropEvent("prop70", "eVar70", 'scrolledToBottom:link:mens-everyday');
            S20.changeSection('mens-everyday', 'navButton' );
      });
      $(".background-panel__button--womens").click(function(e){
            e.preventDefault();
            S20.settings.sectionCount = 0;
            S20.trackPropEvent("prop70", "eVar70", 'scrolledToBottom:link:womens-everyday');
            S20.changeSection('womens-everyday', 'navButton' );
      });

  };

    S20.reorderSections = function (sectionSelected) {
        console.log('prevAll', $("#" + sectionSelected).prevAll());

        //todo: move this to nav only
        //sections ahead of first selected  //only want this to trigger on first page load or nav event
        var previousSections = $("#" + sectionSelected).prevAll().toArray().reverse();
        /*
        previousSections.each(function () {

            $(this).appendTo($("#" + sectionSelected).parent());
        });*/

        $.each(previousSections, function (index, value) {
            $(this).appendTo($("#" + sectionSelected).parent());
        })
}

    S20.goToNavSection = function (that) {
        //change the background section in the flyout nav

            //const sectionSelected = $( that ).data( "section" );
            const index = $(that).index();
            $(that)
                .parent()
                .parent()
                .find(".selected")
                .removeClass("selected");
            $(that)
                .addClass("selected");

            $(that)
                .parent()
                .parent()
                .find(`.nav-panel__background:eq(${index - 1})`)
                .addClass("selected");

            //S20.changeSection( sectionSelected );

    };

    S20.changeSection = function ( sectionSelected, changeAction ) {
    //console.log( sectionSelected, changeAction );

      let sectionClassName = Object.keys(S20.settings.sectionId).find(key => S20.settings.sectionId[key] === sectionSelected);


    $( ".nav-bar > div, .nav-panel__transition > div, #lookbook" )
      .attr( "class", "" )
      .addClass( sectionClassName );

      if (sectionSelected.includes('women')){
          $("#mens-container").hide().removeClass("current");
          $("#womens-container").show().addClass("current");

          //sets nav panels to mens when on womens
          $(".nav-panel__selection:odd").each(function () {
              S20.goToNavSection(this);
          });

      } else {
          $("#mens-container").show().addClass("current");
          $("#womens-container").hide().removeClass("current");

          //sets nav panels to womens when on mens
          $(".nav-panel__selection:even").each(function () {
              S20.goToNavSection(this);
          });

      }

      //$(".section-container").removeClass("selected");

    /*temp placement*/
    //need to make this change mens/womens



    //console.log('change section ' + "#"+sectionSelected);

      let url = window.location.href.replace(location.hash,"");
      url = url + "#"+sectionSelected;//use obj map for urls
      let pageTitle = '';
      var nextTop = 0;

      if (changeAction == 'init') {
            //don't add to history, make new url (you don't want the back button to be a loop on the first page load)

            history.replaceState({
                id: sectionSelected
            }, pageTitle, url);

            S20.reorderSections(sectionSelected);

      } else if (changeAction == 'browserButton') {

          //do nothing but update section
          console.log("browserButton");

      } else if (changeAction == 'navButton') {

            S20.reorderSections(sectionSelected);
            //change history so back buttons work
            history.pushState({
                id: sectionSelected
            }, pageTitle, url);

            nextTop = $("#" + sectionSelected).offset().top;

      } else if (changeAction == 'navScroll') {


          //change history so back buttons work
          history.pushState({
              id: sectionSelected
          }, pageTitle, url);

          $(".section-container").removeClass("selected");
          $("#" + sectionSelected).addClass("selected");

          //S20.addScrollMagic();

          return;

      }else{

            //change history so back buttons work
            history.pushState({
            id: sectionSelected
            }, pageTitle, url);

            nextTop = $("#" + sectionSelected).offset().top;
       }

//console.log(sectionSelected,pageTitle,url);




    //stop the scroll inertia
      //$("body").css({ "overflow": "hidden", "height": "100%" });
      $("body").css({ "overflow": "hidden" });

    //setTimeout(function(){

      S20.resetScrollMagic();



      //$("html, body").animate({ scrollTop: 0 },0);


      //stop animating back up when scroll reaches bottom
      $('.nav-bar__line').addClass("hidden");

      $(".section-container").removeClass("selected");


      $( ".nav-panel__transition" ).addClass( "section-change" );//sets up css delay then transition
      $( "body" ).addClass( "header-nav" );//add remove this to go black then curtain color up

      setTimeout(function(){
        $( "body" ).removeClass( "header-nav" );
      },100);


      setTimeout(function(){//need this delay for the bottom scroll nav change, scroll magic change is slow
        $("#"+sectionSelected).addClass("selected");
        $("body").attr("style","");
        //scroll to top of next section'
        console.log(nextTop);
        $("html, body").animate({ scrollTop: nextTop }, 0);


        setTimeout(function(){
          S20.addScrollMagic();


          setTimeout(function(){

            //used to reset slick slideshows that may not have initialized on proper width (they could have been hidden)
            if ($(".slick-photo-group.slick-initialized").length){
              if($(".slick-photo-group.slick-initialized").slick) {
                $(".slick-photo-group.slick-initialized").slick("refresh");
              } else {
                // this is a very hack fix for mobile where it does not initialize slick until first interaction.
                $(".slick-photo-group.slick-initialized .slick-dots .slick-active:first-child button").click();
              }
            }
          },1000);


        },1000);//let the curtain transition finish so the page has height

      },500)

    //},500)




  };

  S20.elementSetup = function () {
    if ( S20.settings.isDevice ) {
      $( "body" )
        .addClass( "device" );
    } else {
      $( "body" )
        .addClass( "desktop" );
    }
    if ( S20.settings.isApp ) {
      $( "body" )
        .addClass( "app" );
    }

    //console.log('add body IE class',S20.settings.isIE);
    if ( S20.settings.isIE ) {
      //setTimeout(function(){
        $( "#content" ).addClass( "ie" );

      //},500)
      }
      if (S20.settings.isIOS) {
          $("#content").addClass("ios");
      }

    if ( $( "#mobile-sized" )
      .is( ":visible" ) || S20.settings.isDevice ) {
      S20.settings.parallaxEnabled = false;
    } else {
      S20.settings.parallaxEnabled = true;
    }




  };

  S20.resetScrollMagic = function () {
    // If(!S20.settings.parallaxEnabled){
    if ( typeof S20.settings.scrollMagicController === "object" ) {
      S20.settings.scrollMagicController.destroy( true );
      S20.settings.scrollMagicController = false;
    }

    if ( typeof S20.settings.scrollMagicDesktopController === "object" ) {
      S20.settings.scrollMagicDesktopController.destroy( true );
      S20.settings.scrollMagicDesktopController = false;
    }


      $( ".panel" )
        .each( function () {
          TweenMax.set( $( this, ".full-panel__bg", ".background-panel__content" ), { "clearProps": "all" } );
        } );

    // }
  };


  S20.addScrollMagic = function () {

    //always active version all devices
    //if ( S20.settings.parallaxEnabled ) {
      if ( typeof S20.settings.scrollMagicController !== "object" ) {
        // Init controller
        S20.settings.scrollMagicController = new ScrollMagic.Controller();


          $(".current .section-container .section-changer")
            .not(":last").addClass('fadein')
            .each( function () {
            const $currentTrigger = $( this );

            const nextSection = $currentTrigger.data("next");
            //console.log('$currentTrigger',$currentTrigger,nextSection);


            new ScrollMagic.Scene( {
              "triggerElement": $currentTrigger[0],
              "duration": '100%',
            } )
              .on( "enter", (event) => {
                if (event.scrollDirection == 'FORWARD'){
                    S20.settings.sectionCount++;
                        $currentTrigger.removeClass('fadein');
                    if (S20.settings.sectionCount < 4){
                      //$currentTrigger.removeClass("selected").find(nextSection).addClass( "selected" );
                      S20.changeSection(S20.settings.sectionId[nextSection], 'navScroll');
                      //console.log('Scroll change section');

                    }
                }
                console.log('scroll sectionCount',S20.settings.sectionCount);
              } )
              .triggerHook( 0.75 )
            // .addIndicators()
              .addTo( S20.settings.scrollMagicController );
          } );
      }
    //}

    //do the DESKTOP version
    if ( S20.settings.parallaxEnabled ) {
      if ( typeof S20.settings.scrollMagicDesktopController !== "object" ) {
        // Init controller
        S20.settings.scrollMagicDesktopController = new ScrollMagic.Controller();


        /*
         * If ($(".hero.lifestyle").length > 0){
         *
         * var tLifestyleHero = new TimelineMax()
         * .to($(".hero.lifestyle .content")[0], 1, {y:'+=200',opacity:0, ease:Linear.easeInOut})
         *
         *
         * new ScrollMagic.Scene({
         * triggerElement: $(".hero.lifestyle")[0],
         * duration:'100%'
         *
         * })
         * //.addIndicators() // add indicators (requires plugin)
         * .triggerHook(0)
         * .setTween(tLifestyleHero)
         * .addTo(S20.settings.scrollMagicController);
         *}
         */
//console.log('init scrollmagic');

          $( ".current .section-container .panel" )
          .not( ".panel .panel" )
          .each( function () {
            const currentTrigger = $( this )[0];
            const currentDuration = "50%";// $(this).height()/2;

            const tweenImage = new TimelineMax()
              .fromTo( $( this ), 1, { "opacity": 0 }, { "opacity": 1, "ease": Linear.easeOut }, 0 );

            new ScrollMagic.Scene( {
              "triggerElement": currentTrigger,
              "duration": currentDuration,
            } )
              .triggerHook( 1 )
            // .addIndicators()
              .setTween( tweenImage )
              .addTo( S20.settings.scrollMagicDesktopController );
          } );


          $(".current .section-container .pinned-container").each(function(){
            //move inner __bg downward if parent panel height is greater
            var $that = $(this);
            var currentTrigger = $that[0];
            var $backgroundImage = $that.find(".full-panel__bg");
            var $backgroundContent = $that.find(".background-panel__content");

            var coverAnimation = new TimelineMax()
              //.set($that, {overflow:"hidden"})
              .to($backgroundImage, 1, {height:'0', ease:Linear.easeNone}, 0)
              .to($backgroundContent, 1, {top:-$backgroundContent.height(), "opacity": 0, ease:Linear.easeNone}, 0);

            // create scene to pin and link animation
            new ScrollMagic.Scene({
                triggerElement: currentTrigger,
                triggerHook: 0,
                //offset:50,
                duration: $that.height(),
              })
              .setTween(coverAnimation)
              .setPin(currentTrigger, {pushFollowers: false})
              .addTo(S20.settings.scrollMagicDesktopController);
          });


          $(".current .section-container").each(function(){

            var $currentTrigger = $(this);
              var progressvalue = 0;

              let sectionSelected = $currentTrigger.attr("id");
              let sectionClassName = Object.keys(S20.settings.sectionId).find(key => S20.settings.sectionId[key] === sectionSelected);

            //console.log('$currentTrigger.height() , $(window).height()',$currentTrigger.height(),$(window).height());

            new ScrollMagic.Scene({
            triggerElement: $currentTrigger[0],
            duration: $currentTrigger.height()-$(".header-container").height(),
            offset:$(".header-container").height()*-1-1
            })
            .on("progress", function(e) {
            progressvalue = Math.floor(100 * e.progress);
            //console.log(progressvalue);

            if (progressvalue > 99){
              //hidden on nav change instead
              //$('.nav-bar__line').addClass("hidden");
            } else {

              $(".nav-bar > div, .nav-panel__transition > div, #lookbook")
                  .attr("class", "")
                  .addClass(sectionClassName);

              $('.nav-bar__line').removeClass("hidden");

            }
            $('.nav-bar__line').css('height',progressvalue +"%");
            })
            .triggerHook(0)
            //.addIndicators()
            //.setTween(tweenImage)
            .addTo(S20.settings.scrollMagicDesktopController);


          })

          $(".current .panel-text").each(function(){

            var $currentTrigger = $(this);
            var tweenElement = $(this)[0];

            var tImage = new TimelineMax()
            .fromTo(tweenElement, 1, {opacity:0},{opacity:1, ease:Linear.easeInOut},0);
            //.fromTo(tweenElement, 1, {y:'-=100'},{y:'+=100', ease:Linear.easeInOut},0);

            new ScrollMagic.Scene({
              triggerElement: $currentTrigger[0],
              //duration: $currentTrigger.height(),
              duration: 0,
            })


            .triggerHook(.7)
            //.addIndicators()
            .setTween(tImage)
            .addTo(S20.settings.scrollMagicDesktopController);

          })

          $(".current .photo-group .photo").not(".photo .photo").each(function(){

            var $currentTrigger = $(this);
            var tweenElement = $(this)[0];

            $(this).addClass('fadein');

            /*
            var tImage = new TimelineMax()
            //.fromTo(rule, {tweenElement, 1, {backgroundPositionY:0},{backgroundPositionY:'-50px', ease:Linear.easeInOut},0);
            .to(tweenElement, 1, {y:'+=50px',marginBottom:'+=50px',height:'-=50px', ease:Linear.easeInOut},0);

            new ScrollMagic.Scene({
              triggerElement: $currentTrigger[0],
              duration: $currentTrigger.height(),
            })


            .triggerHook(0)
            //.addIndicators()
            .setTween(tImage)
            .addTo(S20.settings.scrollMagicDesktopController);
            */




            //var tImage2 = new TimelineMax()
            //.fromTo(rule, {tweenElement, 1, {backgroundPositionY:0},{backgroundPositionY:'-50px', ease:Linear.easeInOut},0);
            //.from(tweenElement, 1, {y:'+=100px',opacity:0, ease:Linear.easeInOut},0);

            new ScrollMagic.Scene({
              triggerElement: $currentTrigger[0],
              duration: $currentTrigger.height(),
            })

            .on("enter",function(){
              $currentTrigger.removeClass("fadein");
            })

            .triggerHook(.7)
            //.addIndicators()
            //.setTween(tImage2)
            .addTo(S20.settings.scrollMagicDesktopController);


          })




      }
    }
  };


  S20.trackPropEvent = function( prop, eVar, eventString ) {
    const propObject = {};
    const eVarObject = {};

    propObject[prop] = eventString;
    eVarObject[eVar] = eventString;

      eVarObject['eVar3'] = window.location.href;
     //console.log('propObject', propObject);
     //console.log('eVarObject', eVarObject);


    ARCTERYX.analytics.trackEvent( {
      "category": "lookbook",
      "action": "",
      "label": eventString,
      "props": propObject,
      "eVars": eVarObject,
    } );
};



  S20.windowResize = function () {
    S20.resetScrollMagic();
    // SetTimeout(function(){
    //S20.elementSetup();
    S20.addScrollMagic();

    // },15000);
  };





( function ( $ ) {
  $( document )
    .ready( () => {
      S20.common.init();

      S20.elementSetup();

      S20.addHandlers();

      //S20.addScrollMagic();
    } );

}( jQuery ) );

jQuery( window )
  .resize( () => {
  // Slow down functions called on resize
    clearTimeout( S20.resizer );
    S20.resizer = setTimeout( S20.windowResize, 150 );
  } );

/*
 * JQuery(window).on('load', function(){
 *
 * });
 */

if ( window.addEventListener ) {
  window.addEventListener( "orientationchange", S20.windowResize, false );

  window.addEventListener('popstate', function (event) {
    if (history.state && history.state.id) {
        S20.changeSection(history.state.id,'browserButton');
    }
  }, false);
}